import React from 'react';
import { getCurrentUser } from '../../lib/auth';
import { FaEdit, FaCog } from 'react-icons/fa';

interface ProfileHeaderProps {
  onEditProfile: () => void;
  onSettings: () => void;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ onEditProfile, onSettings }) => {
  const user = getCurrentUser();

  return (
    <div className="relative w-full bg-gradient-to-b from-gray-900 to-black py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center space-x-6">
          <div className="relative">
            <img
              src={user?.profile_image || `https://api.dicebear.com/7.x/initials/svg?seed=${user?.email}`}
              alt="Profile"
              className="w-24 h-24 rounded-full border-4 border-white object-cover"
            />
          </div>
          
          <div className="flex-1">
            <h1 className="text-2xl font-bold text-white">{user?.username || user?.email.split('@')[0]}</h1>
            <p className="text-gray-400 mt-1">{user?.email}</p>
            
            <div className="flex items-center space-x-4 mt-4">
              <button
                onClick={onEditProfile}
                className="flex items-center px-4 py-2 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-lg text-sm font-medium shadow-lg hover:from-red-600 hover:to-pink-600 transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
              >
                <FaEdit className="w-3.5 h-3.5 mr-1.5" />
                Edit Profile
              </button>
              
              <button
                onClick={onSettings}
                className="flex items-center px-3 py-2 bg-gray-800 text-white rounded-lg text-sm hover:bg-gray-700 transition-colors"
              >
                <FaCog className="w-3.5 h-3.5 mr-1.5" />
                Settings
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;